<template>
  <el-container class="app-wrapper">
    <Sidebar />
    <el-container class="main-container">
      <el-header class="header">
        <Navbar />
      </el-header>
      <TagsView />
      <el-main>
        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cachedViews">
            <router-view :key="key" />
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "./Sidebar/Index";
import Navbar from "./Navbar/Index";
import TagsView from "./TagsView/Index";

export default {
  name: "Layout",
  data() {
    return {
      cached: ""
    };
  },
  components: {
    Sidebar,
    Navbar,
    TagsView
  },
  computed: {
    ...mapGetters(["permission_routers", "cachedViews"]),
    key() {
      return this.$route.path;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100%;
}
.header {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  position: relative;
  .el-menu-demo {
    border: unset !important;
  }
  .avatar-container {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    height: 100%;
    .avatar-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
.logo-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  img {
    width: 30px;
    height: 30px;
  }
}
.el-main {
  background-color: #f3f6f8;
  padding: 10px !important  ;
}
</style>
